import { create } from 'zustand';
import { immer } from 'zustand/middleware/immer';

import { createRoleActions } from './actions';
import { RoleActions, RoleState } from './types';

export const useRoleStore = create<RoleState & RoleActions>()(
    immer((set, get, store) => ({
        roles: [],
        loading: false,
        selectedRole: null,
        loadingRole: false,
        error: undefined,
        ...createRoleActions(set, get, store),
    })),
);
